import { render, staticRenderFns } from "./SignupChoices.vue?vue&type=template&id=4de2be52&scoped=true&"
import script from "./SignupChoices.vue?vue&type=script&lang=js&"
export * from "./SignupChoices.vue?vue&type=script&lang=js&"
import style0 from "./SignupChoices.vue?vue&type=style&index=0&id=4de2be52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2be52",
  null
  
)

export default component.exports